var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoApplicants({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12_77461)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.9772 20.9434H21.9702C20.9178 20.944 19.9087 21.3566 19.1645 22.0904C18.4203 22.8243 18.002 23.8194 18.0013 24.8572V95.4372C18.002 96.475 18.4203 97.4702 19.1645 98.204C19.9087 98.9379 20.9178 99.3504 21.9702 99.3511H99.9772C101.03 99.3505 102.039 98.938 102.783 98.2042C103.527 97.4703 103.946 96.4751 103.946 95.4372V24.8572C103.946 23.8193 103.527 22.8241 102.783 22.0903C102.039 21.3564 101.03 20.9439 99.9772 20.9434Z",
    fill: "#C2C4CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5267 41.4268L54.3591 54.0817H41.5267V41.4268Z",
    fill: "url(#paint0_linear_12_77461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.96 57.7571L104.427 96.383C104.15 98.314 102.475 99.7492 100.497 99.7492H21.4471C19.4696 99.7492 17.7938 98.314 17.5172 96.383L10.0397 44.19C9.70242 41.8338 11.5565 39.7285 13.9696 39.7285H38.3819C40.3594 39.7285 42.0352 41.1637 42.3118 43.0943L43.2918 49.9294C43.5684 51.8604 45.2442 53.2956 47.2217 53.2956H106.031C108.443 53.2956 110.298 55.4008 109.961 57.7571H109.96Z",
    fill: "#DEDFE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.3555 82.5223H31.5895C31.2674 82.5222 30.9564 82.4062 30.7147 82.1962C30.4731 81.9862 30.3174 81.6965 30.2768 81.3814L29.5415 75.6407C29.5182 75.4571 29.5347 75.2707 29.59 75.0938C29.6452 74.9169 29.738 74.7537 29.8622 74.6148C29.9863 74.476 30.139 74.3648 30.31 74.2886C30.481 74.2124 30.6666 74.173 30.8542 74.1729H91.0907C91.2784 74.173 91.4639 74.2124 91.635 74.2886C91.806 74.3648 91.9587 74.476 92.0828 74.6148C92.2069 74.7537 92.2997 74.9169 92.355 75.0938C92.4103 75.2707 92.4268 75.4571 92.4034 75.6407L91.6682 81.3814C91.6276 81.6965 91.4719 81.9862 91.2302 82.1962C90.9886 82.4062 90.6776 82.5222 90.3555 82.5223Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12_77461",
    x1: 50.005,
    y1: 56.1121,
    x2: 34.7104,
    y2: 40.603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2CECE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179,
    stopColor: "#AFBCBC",
    stopOpacity: 0.179
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B6A6A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12_77461"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 83,
    fill: "white",
    transform: "translate(10 18.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoApplicants);
export default __webpack_public_path__ + "static/media/no-applicants.9aed0c735e4a874e268e1ef88ee67521.svg";
export { ForwardRef as ReactComponent };